import { Component, Inject } from '@angular/core';
import { Agb } from '@libs/index';
import { User } from '@libs/index';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { UserService } from '@libs/index';
import { StateService } from '../../../services/state/state.service';
import { ErrorHandlerServiceService } from '@libs/index';

export interface AgbToAcceptDialogComponentData {
  agb: Agb;
  user: User;
}

@Component({
  selector: 'app-agb-to-accept-dialog',
  templateUrl: './agb-to-accept-dialog.component.html',
  styleUrls: ['./agb-to-accept-dialog.component.scss'],
})
export class AgbToAcceptDialogComponent {
  public agb: Agb;
  public isLoading = false;

  private user: User;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: AgbToAcceptDialogComponentData,
    private dialogRef: MatDialogRef<AgbToAcceptDialogComponent>,
    private errorHandlerServiceService: ErrorHandlerServiceService,
    private stateService: StateService,
    private authenticationService: AuthenticationService,
    private userService: UserService
  ) {
    this.agb = this.data?.agb;
    this.user = this.data?.user;
  }

  public async submit() {
    this.isLoading = true;

    try {
      const isSuccess = await this.userService.updateAgbAgreement(
        this.user?.id,
        this.agb?.version
      );

      if (isSuccess) {
        const user = await this.userService.getCurrentLoggedInUser();
        this.stateService.setUser(user);
        this.closeDialog();
      }
    } catch (e) {
      this.errorHandlerServiceService.handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  public async deny() {
    this.isLoading = true;

    try {
      const isLoggedOut = await this.authenticationService.logout();

      if (isLoggedOut) {
        this.closeDialog();
      }
    } catch (e) {
      this.errorHandlerServiceService.handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  private closeDialog(): void {
    this.dialogRef.close();
  }
}
